/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { MOUSE_ACTIVATION, SideBySideMagnifier, TOUCH_ACTIVATION } from 'react-image-magnifiers';
import ReactHTMLParser from 'react-html-parser';
import { Fade } from '@material-ui/core';
import LazyLoad from 'react-lazyload';

import {
    object, shape, string, bool, func,
} from 'prop-types';

import { shouldRenderSnipe, snipePath, isSnipeImageActive } from '../common/commonProductPageHelper';
import SnipeRenderQuery from '../common/SnipeRenderQuery';
import SnipeRender from '../common/SnipeRender';
import FavoritesUI from '../../../GraphqlCommonComponents/Favourite/FavouriteUi';

const ProductImageMagnifierUI = ({
    classes, imagePath, data, isSnipeImageShow, personalizationFlag, renderSnipeImage, setIsZoomed, // isZoomed,
}) =>  {
    const fullResolutionSrc = imagePath.replace('x.', 'xlx.');
    const triggerAction  = (action) => {
        renderSnipeImage(action);
        setIsZoomed(action);
    };
    return (
        <div className={classes.magnifierContainer}>
            <SideBySideMagnifier
                className={classes.productImage}
                imageSrc={[fullResolutionSrc, `${imagePath}`]}
                imageAlt={ReactHTMLParser(data?.name)}
                alwaysInPlace
                touchActivation={TOUCH_ACTIVATION.TAP}
                mouseActivation={MOUSE_ACTIVATION.HOVER}
                transitionSpeedInPlace={0.25}
                onZoomEnd={() => {
                    triggerAction(false);
                }}
                onZoomStart={() => {
                    triggerAction(true);
                }}
                cursorStyle="url('https://images.contentstack.io/v3/assets/blt89dbf1c763ec00a6/blt1a21d16c41b8b8a9/6297161fdf98c90faab8833e/mouseCross.svg'), auto"
            />

            {isSnipeImageShow && shouldRenderSnipe(data?.image?.snipe, personalizationFlag) && isSnipeImageActive(data?.image, 'pdp')  ? ( // if snipe data exsist display snipe img
                <LazyLoad>
                    <Fade in timeout={700}>
                        <SnipeRender
                            altText={ReactHTMLParser(data?.image?.altText)}
                            styleProp={classes.snipe}
                            src={`${data?.image?.snipeImagePath}${data?.image?.snipe}_z.gif?auto=webp`}
                            fallbackSrc={`${snipePath(data.image.path)}${data?.image?.snipe}_z.gif?auto=webp`}
                        />
                    </Fade>
                </LazyLoad>
            ) : null}
            { isSnipeImageShow && <SnipeRenderQuery  partNumber={data?.partNumber || data?.id}  productType="product" />}
            <FavoritesUI partNumber={data?.partNumber || data?.id} />
        </div>
    );
};
ProductImageMagnifierUI.propTypes = {
    classes: object.isRequired,
    imagePath: string,
    isSnipeImageShow: bool,
    data: shape({
        partNumber: string,
        id: string,

        image: shape({
            path: string,
            snipe: string,
            snipeImagePath: string,
            altText: string,
        }),
    }),
    personalizationFlag: bool,
    renderSnipeImage: func,
    setIsZoomed: func,
};

ProductImageMagnifierUI.defaultProps = {
    imagePath: '',
    data: {},
    isSnipeImageShow: false,
    personalizationFlag: false,
    renderSnipeImage: () => {},
    setIsZoomed: () => {},
};

export default ProductImageMagnifierUI;
